function Zahvala() {
  return (
    <div className="page-wrapper">
      
      <div className="page-content">
        <div>
          <h1>Hvala ti na prijavi 🚗</h1>
          <p>Zaprimili smo tvoju prijavu i javit ćemo se uskoro.</p>
        </div>
      </div>

    </div>
  );
}

export default Zahvala;